import styled from 'styled-components';

export const LinkEquipo = styled.a`
  color: ${props => props.theme.colors.info};
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    color: ${props => props.theme.colors.infoHover};
    text-decoration: underline;
  }
`;

export default LinkEquipo;
